// Keep successful dice evidence for one reaction across retries and page refreshes.
const evidence=new Map();
export async function cachedOpportunityRoll(opportunityId,key,roll){
 if(!opportunityId)return roll();
 const id=`opportunity-dice:${opportunityId}:${key}`;
 if(evidence.has(id))return evidence.get(id);
 try{const saved=sessionStorage.getItem(id);if(saved){const result=JSON.parse(saved);evidence.set(id,result);return result;}}catch{/* Optional browser recovery storage. */}
 const result=await roll();evidence.set(id,result);
 try{sessionStorage.setItem(id,JSON.stringify(result));}catch{/* In-memory evidence still prevents rerolling. */}
 return result;
}
